import { cn } from '@/utils/cn';

interface SourcePillProps {
  label: string;
  color?: string;
  className?: string;
}

export function SourcePill({ label, color = '#94A3B8', className }: SourcePillProps) {
  return (
    <span
      className={cn('ds-tag', className)}
      style={{ background: color + '15', color, fontWeight: 500 }}
    >
      {label}
    </span>
  );
}
